import React from 'react'
import SellerHeader from '../../components/SellerHeader'
import ShopDetailsForm from '../../components/ShopDetailsForm'

const EditShop = () => {
  return (
    <div>
        <SellerHeader />
        <ShopDetailsForm />
    </div>
  )
}

export default EditShop